namespace Core.Destinations {

    export enum DestinationType {
        Establishment = 1,
        Location = 2,
        Province = 3,
        Country = 4,
        Place = 5,
        Polygon = 10,
        Universal = 12
    }

    export interface DestinationSummary {
        Id: number;
        Type: DestinationType;
        Title?: string;
        ImageUrl?: string;
        PagePath?: string;
    }

    export interface DestinationContentCard extends DestinationSummary {
        HolidayEnabled: boolean;
        HotelCount: number;
        MinFlightPrice: number;
        MinHotelPrice: number;
        PagePath: string;
        Searchable: boolean;
        RecommendationType: number;
    }

}
